<template>
    <div>
        <SphereNavigation color="blue" selected="appointment-menu" />

        <div class="inner-content">
            <h1>{{$t('appointments.title')}}</h1>

            <div class="action-btns">
                <button type="button" class="btn-basic blue" @click.prevent="clickNewAppointment">
                    {{$t('appointments.btn')}}
                </button>
                <button type="button" class="btn-basic blue" @click.prevent="clickStaffAppointment">
                    {{$t('appointments.staff')}}
                </button>
            </div>
        </div>
    </div>
</template>

<script>
import SphereNavigation from "@/components/app/SphereNavigation.vue";
import {apiStore} from "@/stores/api";

export default {
    name : "AppointmentMenu",
    components : {
        SphereNavigation
    },

    methods: {
        clickNewAppointment() {
            if (apiStore().shop && apiStore().shop.show_service_type === true) {
                this.$router.push({name : "appointment-type"});
            } else {
                this.$router.push({name : "appointment-edit"});
            }
        },

        clickStaffAppointment() {
            this.$router.push({name : "appointment-staff"});
        }
    }
};
</script>

<style lang="scss" scoped>
    .inner-content {
        .action-btns {
            margin-top : 5rem;
            text-align : left;
            margin-left: 11%;

            .btn-basic {
                padding : 0 2rem;
                margin-right : 1rem;
                margin-bottom : 1rem;
            }
        }
    }
</style>